import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { DeleteModal } from "../../../../revampComponents/Atom/Modals";
import LoadingSpinner from "../../../../revampComponents/Atom/Loading";
import customToast from "../../../../components/common/basic/Toast";
import { baseUrl } from "../../../../config/config";
import { getCoupons } from "../../../../revampCRUD/copounNcharges.crud";
import { dashboardColors, theme } from "../../../../themes/Theme";

const AddSingleRegistrationForm = ({
  setShowFormModal,
  setSelectedTicket,
  selectedTicket,
  registrationUrl,
  setRegistrationUrl,
  prop,
  refreshData = () => { },
  selectedAccessCode,
  setSelectedAccessCode,
  setShowAddRegistrationModal
}) => {
  const [showBackModal, setShowBackModal] = useState(false);
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);
  const [accessCodesData, setAccessCodesData] = useState('');
  const [canDisplayIframe, setCanDisplayIframe] = useState(false);


  useEffect(() => {
    const timer = setTimeout(() => {
      setCanDisplayIframe(true);
    }, 7000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleMessage = (event) => {
      // Optional: validate origin with event.origin === 'https://dev.konfhub.com'
      if (event.data?.type === "closeModal") {
        const responseMessage = event.data?.response?.message;
        if (responseMessage === "Attendee Added Successfully.") {
          refreshData();
          customToast.success(
            "Attendee Added Successfully.")
          setShowFormModal(false);
          setSelectedTicket({});
          setRegistrationUrl("");
          setSelectedAccessCode("")

        }
      } else if (event.data?.type === "closeModalOnCancel") {
        setShowBackModal(true)
        setRegistrationUrl("");

      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <>
      <div className="d-flex flex-column px-4 top-heading-cont-add-registration">
        <div
          className="d-flex align-items-center gap-2 mb-3 "
        >
          <img onClick={() => setShowBackModal(true)} className="cursor-pointer" src="../../../../assets/images/back-icon.svg" alt="" />{" "}
          <p className="select-ticket-single-registration ml-2 mb-0">
            Add Single Registration
          </p>
        </div>
        <p className="ticket-name-single-registration mb-0">
          Ticket Name: <span>{selectedTicket?.label}</span>
        </p>
      </div>
      <form style={{ height: "400px" }} className=" ">
        {!(isIframeLoaded && canDisplayIframe) && <LoadingSpinner />}
        <div className="add-single-registration-iframe" style={{ display: isIframeLoaded && canDisplayIframe ? 'block' : 'none' }}>
          <iframe
            onLoad={() => setIsIframeLoaded(true)}
            src={`${baseUrl}/ad/${prop.eventInfo.event_url}?ticketId=${selectedTicket?.value}&eventId=${prop.eventInfo.event_id}&adminDashboard=true&screen=2&btnBg=002e6e&secondaryBg=FFFFFF${selectedTicket?.isHidden ? `&selectedCode=${selectedAccessCode?.label}` : ''
              }`}
            className="w-100 h-100 height-iframe"
            allowfullscreen></iframe></div>
        <DeleteModal
          width={"364px"}
          openModal={showBackModal}
          setOpenModal={setShowBackModal}
          primaryBtnContent={"Yes"}
          cancelBtnContent={"No"}
          item=""
          text={`Going back will discard entered data. <br />
Do you want to proceed?`}
          onCancel={() => {
            setShowBackModal(false);
            setShowFormModal(true);
          }}
          onOkay={() => {
            setShowBackModal(false);
            setSelectedTicket({});
            setShowFormModal(false);
            setShowAddRegistrationModal(true)
          }}
        />
      </form>
      <style>
        {`
                
        .select-ticket-single-registration{
            font-size:18px;
            color: ${dashboardColors[theme].primaryTextColor};
            font-weight:500;
        }
        .top-heading-cont-add-registration{
          padding-left: 17px !important;
          padding-right: 20px !important;
        }
        .ticket-name-single-registration{
            font-size:15px;
            color: ${dashboardColors[theme].primaryTextColor};
            font-weight:400;
        }
.add-single-registration-iframe {
  width: 100%;
  height: 100%;
 
}
           .add-single-registration-iframe iframe{
             border: 0 !important;
           }     
    `}
      </style>
    </>
  );
};

export default AddSingleRegistrationForm;
